<template>
  <div class="boolean-search-layout boolean-search-landing">

    <div class="sidebar-section one-row">
      <landing-sidebar />
    </div>

    <section>
      <div class="search-section-background"></div>
      <div class="search-section">
        <div class="search-fields flex-2to1" >
          <!-- top search bar -->
          <search
              v-model="searchFraze"
              class="queries-search flex-2"
              :focus="searchFocus"
              :is-searching="isSearching"
              @search="searchQueries"
              @clearSearch="clearSearch"
              :shadow="true"
          />

          <multi-select
              v-if="resourceType !== 'groups' && !isTag"
              id="bool_search_type"
              :options="searchTypeOptions"
              v-model="selectedTypeModel"
              label="label"
              track-by="value"
              :multiple="true"
              :allowEmpty="true"
              :loading="isSearching"
              :closeOnSelect="false"
              :showLabels="true"
              :placeholder="$t('booleanSearch.filter_by_type')"
              class="search-type-select shadow-md">
            <template slot="selection" slot-scope="{ values }">
              <div class="select-values" v-if="values.length">
                <span v-for="(value, i) in values" :key="value.value">{{`${value.label}${values.length -1 != i ? ', ' : ''}`}}</span>
              </div>
            </template>

            <span
                v-if="selectedTypeModel && selectedTypeModel.length > 0"
                slot="clear"
                class="clear-select"
                @mousedown.prevent.stop="() => { selectedTypeModel = [] }"
            >
          <i
              class="fas fa-times"
          ></i>
          </span>
          </multi-select>
          <div class="actions">
            <button
                v-if="isTag && showPrivateTags"
                :class="{'action-btn-carma': tag_library.filters.visibility}"
                class="search-export-dropdown btn shadow-md icon-m-0 ml10"
                style="background-color: rgb(237, 237, 237);"
                @click="toggleVisibilityFilter"
                v-tooltip="$t('booleanSearch.tagsVisibility')"
            >
              <i v-if="tag_library.filters.visibility === 'private'" class="far fa-eye-slash"></i>
              <i v-else class="far fa-eye"></i>
            </button>
            <button
                v-if="isTag"
                :class="{'action-btn-carma': isAlphaSorting}"
                class="search-export-dropdown btn shadow-md icon-m-0 ml10"
                style="background-color: rgb(237, 237, 237);"
                @click="toggleAlphaSort"
                v-tooltip="$t('booleanSearch.sort.sort_by_name')"
            >
              <i v-if="sortState == 'alphaDesc'" class="fas fa-sort-alpha-up"></i>
              <i v-else class="fas fa-sort-alpha-down"></i>
            </button>
            <button
                v-if="isTag"
                :class="{'action-btn-carma': isDateSorting}"
                class="search-export-dropdown btn shadow-md icon-m-0 ml10"
                style="background-color: rgb(237, 237, 237);"
                @click="toggleDateSort"
                v-tooltip="$t('booleanSearch.sort.sort_by_date')"
            >
              <i v-if="sortState == 'dateAsc'" class="fas fa-sort-amount-up"></i>
              <i v-else class="fas fa-sort-amount-down"></i>
            </button>
            <dropdownButton
                v-if="isTag"
                :options="selectOptions"
                :icon="'fas fa-check-square'"
                :customCss="`search-export-dropdown btn btn-default-light shadow-md icon-m-0 ml10`"
                @cancelSelection="cancelSelection"
                @makePublic="changeVisibility(true)"
                @makePrivate="changeVisibility(false)"
                @cloneSelection="cloneSelection"
                @deleteSelection="deleteSelection"
                :disabledProp="zeroTagSelected"
            />
            <button
                v-if="resourceType === 'searches' || resourceType === 'tagsSearches'"
                v-tooltip="$t('booleanSearch.export_all')"
                class="search-export-dropdown btn btn-default-light shadow-md icon-m-0 ml10"
                @click="onExport"
            >
              <i class="far fa-download"></i>
            </button>
            <button
                v-if="showNetfeedrSearchUpload && !isTag"
                v-tooltip="$t('booleanSearch.upload')"
                class="search-export-dropdown btn btn-default-light shadow-md icon-m-0 ml10"
                @click="onNetfeedrUpload"
            >
              <i class="far fa-upload"></i>
            </button>
            <button
                v-tooltip="$t(isTag ? 'booleanSearch.upload_tag' : 'booleanSearch.upload_v3')"
                class="search-export-dropdown btn btn-default-light shadow-md icon-m-0 ml10"
                @click="onUpload"
            >
              <i class="far fa-upload"></i>
            </button>

          </div>
        </div>

        <div class="text-center">
          <loader-inline v-if="!isInitiated" />
          <dots-divider v-else class="mb10" />
        </div>
      </div>

      <div>
        <div>
          <div v-if="isTag && !tag_library.isBusy && data.length" class="select-all-checkbox">
            <input @click.stop type="checkbox" 
            :checked="allTagsSelected" 
            @change="selectAll"
            >
            <p>{{ $t('booleanSearch.select.all') }}</p>
          </div>
          <!-- for searches & groups -->
          <transition-group v-if="!isTag" tag="ul" name="list">
            <query-list-item
                v-for="(query, index) in data"
                :key="`query-${query.id}-${index}`"
                :resource-name="resourceName"
                :item="query"
                :is-deleted="deletedQuery && deletedQuery.id === query.id"
            />
          </transition-group>
          <!-- for tags -->
          <div v-else-if="!tag_library.isBusy" v-for="(queries, category) in tagsGroupedByCategory" :key="`category-${category}`">
            <CollapsibleFormSection 
              v-if="queries.tags.size > 0"
              :title="`${category}`" 
              :count="countDisplay(queries)"  
              :initShow="false" 
              :allCategorySelected="selectedTags[category] && selectedTags[category].tags.size == tagsGroupedByCategory[category].tags.size"
              @toggleSelectCategory="handleSelectCategory(category)"
            >
              <transition-group tag="ul" name="list" :class="{ 'tag-class': isTag }">
                <query-list-item
                    v-for="([queryId, query]) in Array.from(queries.tags)"
                    :key="`query-${queryId}`"
                    :resource-name="resourceName"
                    :item="query"
                    :is-deleted="deletedQuery && deletedQuery.id === queryId"
                    :showPrivateTags="showPrivateTags"
                    v-tooltip="buildTitle(query)"
                    class="tag-list-item"
                    :selectedTag="selectedTags[category] && selectedTags[category].tags.has(queryId)"
                    @toggleSelectTag="handleSelect(category, query)"
                />
              </transition-group>
              <button 
                v-if="queries.count > queries.tags.size"
                :class="[loadingCategoryTags[category] ? 'load-more-tags-loading' : 'load-more-tags']"
                @click="fetchMoreTags(category, queries.tags.size)"
                :disabled="loadingCategoryTags[category]"
              >{{loadingCategoryTags[category] ? $t('booleanSearch.loading') : $t('booleanSearch.load_more')}}</button>
            </CollapsibleFormSection>
          </div>


          <div v-if="!isTag" class="text-center">
            <p v-if="noData">{{$t('booleanSearch.no_data')}}</p>
            <p v-else-if="allLoaded">{{$t('booleanSearch.all_data_loaded', [listEndResourceName])}}</p>
          </div>

          <div v-if="!isTag" ref="observerBottomTarget"></div>

          <div class="text-center">
            <loader-inline v-if="isInitiated && isBusy" />
          </div>
        </div>
      </div>

    </section>

    <div class="sidebar-section one-row">
      <aside>
        <last-activity-sidebar :resource-name="resourceName" />
      </aside>
    </div>

    <group-action-attn-modal v-if="groupBlocked.groups.length > 0 || groupBlocked.searches.length > 0"
                       @onRetry="() => remove({ key: resourceName, item: itemBlocked })"
    />
    <batch-clone-delete-modal
      v-if="showBatchCloneModal || showDeleteConfirmation.visible" 
      @close="handleCloseModal"
      :data="selectedTags"
      :cancelSelection="cancelSelection"
      :showDeleteConfirmation="showDeleteConfirmation"
    />
    <upload-resources-modal
      :isTag="isTag"
      :variant="isTag ? 'tag' : 'twitter_v3'"
      v-if="showBatchUploadModal"
      @close="handleCloseModal"
    />
    <upload-resources-modal
      :isTag="false"
      variant="netfeedr"
      v-if="showNetfeedrUploadModal"
      @close="handleCloseModal"
    />
    <export-resources-modal
      v-if="showExportModal"
      :isTag = "isTag"
      @close="handleCloseModal"
      @export="(format, filters, callback) => exportSearches({ key: resourceName, formatType: format, item: selectedTags, filters: { ...filters, search_type: selectedTypeModel.map(dt => dt.value) } }).then(() => callback())"
    />
  </div>
</template>

<script>
// Plugins
import { mapActions, mapState } from 'vuex';
import { isEmpty } from 'lodash';
import multiSelect from 'vue-multiselect';

// Components
import landingSidebar from "./sidebars/landing-sidebar.vue";
import search from "../Search.vue";
import dotsDivider from "./common/DotsDivider.vue";
import loaderInline from '../../components/loader-inline.vue'
import lastActivitySidebar from "./sidebars/last-activity-sidebar.vue";
import queryListItem from '../../components/boolean-search/searches/QueryListItem.vue'
import groupActionAttnModal from './modals/GroupActionAttnModal';
import dropdownButton from '../dropdown-button';
import CollapsibleFormSection from '../transitions/CollapsibleFormSection.vue';
import BatchCloneDeleteModal from './modals/BatchCloneDeleteModal';
import UploadResourcesModal from './modals/UploadResourcesModal';
import ExportResourcesModal from './modals/ExportResourcesModal';

// Mixins
import infiniteLoad from "../../mixins/boolean-search/infiniteLoad";
import searchesGroupsSearch from "../../mixins/boolean-search/searchesGroupsSearch";
import storeHelper from "../../mixins/boolean-search/storeHelper";
import remove from '../../mixins/boolean-search/delete.js';
import exportSearches from '../../mixins/boolean-search/export';
import notifyMessages from '../../mixins/boolean-search/notifyMessages';

//Config
import { searchTypes } from '../../config/bool-const';

export default {
name: "SearchesGroupsListPage",
  props: {
    resourceName: {
      type: String,
      required: true
    },
    data: {
      type: Array,
      default: () => []
    },
    noData: Boolean,
    isInitiated: Boolean,
    allLoaded: Boolean,
    canLoadMoreString: {
      type: String,
      required: true,
      default: 'searchesCanLoadMore'
    },
    isBusy: Boolean
  },

  mixins: [ infiniteLoad, searchesGroupsSearch, storeHelper, remove, exportSearches, notifyMessages ],

  data () {
    return {
      loadingCategoryTags: {},
      showDeleteConfirmation: {visible: false},
      showBatchCloneModal: false,
      showBatchUploadModal: false,
      showNetfeedrUploadModal: false,
      // Hidden for now; set true to show the Netfeedr search upload again.
      showNetfeedrSearchUpload: false,
      showExportModal: false,
      selectedTags: {},
      selectedTypeModel: []
    }
  },

  created() {
    this.getProjectSetup({ projectUid: this.project_id });
  },

  mounted() {
    this.resourceName != 'tag_library' && this.initInfiniteLoad(this.resourceName, this.$refs.observerBottomTarget, this.canLoadMoreString)
  },

  computed: {
    ...mapState({
      countByCategory: state => state.booleanSearch.tag_library.countByCategory,
      tag_library: state => state.booleanSearch.tag_library,
      sortState: state => state.booleanSearch.tag_library.sorted,
      groupBlocked: state => state.booleanSearch.group_blocked,
      queryExporting: state => state.booleanSearch.searches.queryExporting,
      projectSetupGeneral: state => state?.projectSetup?.projectSetup?.data?.general
    }),
    project_id() {
      return this.$store.state.booleanSearch.project_id;
    },
    enableSocialInfluencersSearches() {
      return this.projectSetupGeneral?.enable_social_influencers_searches;
    },

    resourceType() {
      return this.resourceName === 'group_library' ? 'groups' : this.resourceName === 'tag_library' ? 'tagsSearches' : this.resourceName;
    },
    
    listEndResourceName() {
      return this.resourceName === 'group_library' ? 'groups' : this.resourceName === 'tag_library' ? 'tags' : this.resourceName;
    },

    isAlphaSorting() {
      return this.sortState === 'alphaDesc' || this.sortState === 'alphaAsc';
    },
    isDateSorting() {
      return this.sortState === 'dateDesc' || this.sortState === 'dateAsc';
    },

    isTag() {
      return this.resourceName === 'tag_library';
    },

    showPrivateTags() {
      return this.tag_library.showPrivateTags;
    },

    tagsGroupedByCategory() {
      if(!this.isTag) return null;
      this.cancelSelection();
      const categories = {};
      this.data.forEach(tag => {
        if(!categories[tag.category]) {
          categories[tag.category] = { tags: new Map(), count: 0 };
        }
        categories[tag.category].tags.set(tag.id, tag);
      });
      this.countByCategory.forEach(item => {
        if(categories[item.category]) {
          categories[item.category].count = item.count;
        } else {
          categories[item.category] = {tags: new Map(), count: item.count};
        }
      });
      return categories;
    },

    searchTypeOptions() {
      const options = searchTypes.reduce((acc, type) => {
        if(Array.isArray(type?.isEnabledKeys)) {
          if(type?.isEnabledKeys?.length > 0 && type?.isEnabledKeys?.filter(k => !!this.projectSetupGeneral?.[k])?.length === type?.isEnabledKeys?.length) {
            acc.push({value: type.value, label: this.$t(type.label, { defaultValue: type.label })});
          }
        } else {
          acc.push({value: type.value, label: this.$t(type.label, { defaultValue: type.label })});
        }
        return acc;
      }, []);
      // Add the multi option
      options.push({ value: 'multi', label: this.$t('booleanSearch.search_type.multi') });
      return options;
    },

    itemBlocked () {
      if(!this.groupBlocked || isEmpty(this.groupBlocked)) return null;

      return this.data.find(d => d.id === this.groupBlocked.group_id);
    },

    exportOptions() {
      return [
        { label: 'Export CSV', action: 'exportCsv' },
        { label: 'Export Excel', action: 'exportXls' },
      ]
    }, 
    
    allTagsSelected() {
      return this.data.length === Object.values(this.selectedTags).reduce((acc, data) => {
        return acc + data.tags.size;
      }, 0);
    },

    zeroTagSelected() {
      return !Object.values(this.selectedTags).some(v => v.tags.size > 0);
    },

    selectOptions() {
      return [
        ...(this.showPrivateTags ? [
          { label: this.$t('booleanSearch.select.make_public'), action: 'makePublic', disabled: this.zeroTagSelected},
          { label: this.$t('booleanSearch.select.make_private'), action: 'makePrivate', disabled: this.zeroTagSelected},
        ] : []),
        { label: this.$t('booleanSearch.select.clone'), action: 'cloneSelection', disabled: this.zeroTagSelected},
        { label: this.$t('booleanSearch.select.delete'), action: 'deleteSelection', disabled: this.zeroTagSelected},
      ]
    }
  },

  watch: {
    selectedTypeModel: {
      handler: function(value) {
        this.searchType = value.map(v => v.value);
        this.searchQueries();
      }
    }
  },

  methods: {
    ...mapActions({
      getMoreTagsByCategory: "booleanSearch/getMoreTagsByCategory",
      batchDeleteTags: "booleanSearch/batchDeleteTags",
      changeTagsSortOrder: "booleanSearch/changeTagsSortOrder",
      getOrderedTags: "booleanSearch/getOrderedTags",
      changeTagsVisibility: 'booleanSearch/changeTagsVisibility',
      getProjectSetup: "projectSetup/getprojectSetup"
    }),

    buildTitle(query) {
        let title = query.regex_query ? `${this.$t('booleanSearch.queries.fields.regex_query.title')}:\n${query.regex_query}\n\n` : '';
        title += query.standard_query ? `${this.$t('booleanSearch.queries.fields.standard_query.title')}: \n${query.standard_query}\n\n` : '';
        title += query.user_query ? `${this.$t('booleanSearch.queries.fields.standard_query.title')}: \n${query.user_query}` : '';
        return title;
    },

    fetchMoreTags(category, length) {
      this.$set(this.loadingCategoryTags, category, true);
      const search = this.searchFraze ? this.searchFraze : '';
      this.getMoreTagsByCategory({orderBy: this.sortState, category, offset: length, search, projectId: this.project_id})
      .then(() => { 
        this.$set(this.loadingCategoryTags, category, false);
      })
      .catch(() => this.$set(this.loadingCategoryTags, category, false))
    },
    toggleVisibilityFilter() {
      const search = this.searchFraze ? this.searchFraze : '';
      this.getOrderedTags({
        orderBy: this.sortState, 
        search, 
        projectId: this.project_id, 
        visibility : this.tag_library.filters.visibility,
        toggleVisibility: true
      }).catch((e) => {this.notifyStoreError(e)})
    },
    toggleAlphaSort() {
      const search = this.searchFraze ? this.searchFraze : '';
      if (this.sortState === 'alphaDesc') this.changeTagsSortOrder({sort: false})
      else if (this.sortState === 'alphaAsc') this.changeTagsSortOrder({sort: 'alphaDesc'})
      else this.changeTagsSortOrder({sort: 'alphaAsc'})
      const opts = {orderBy: this.sortState, search, projectId: this.project_id, visibility: this.tag_library.filters.visibility};
      this.getOrderedTags(opts).catch((e) => {this.notifyStoreError(e)})
    },
    toggleDateSort() {
      const search = this.searchFraze ? this.searchFraze : '';
      if (this.sortState === 'dateAsc') this.changeTagsSortOrder({sort: false})
      else this.changeTagsSortOrder({sort: 'dateAsc'})
      const opts = {orderBy: this.sortState, search, projectId: this.project_id, visibility: this.tag_library.filters.visibility};
      this.getOrderedTags(opts).catch((e) => {this.notifyStoreError(e)})
    },
    countDisplay(queries) {
      if(!queries) return 0;
      return queries.count == queries.tags.size ? queries.count : queries.tags.size + ' / ' + queries.count
    },
    selectAll() {
      if(this.allTagsSelected) this.selectedTags = {};
      else{
        this.selectedTags = {};
        for (const [category, data] of Object.entries(this.tagsGroupedByCategory)) {
          this.selectedTags[category] = {tags: new Map(data.tags)};
        }
      }
    },
    cancelSelection() {
      this.selectedTags = {};
    },
    handleCloseModal() {
      if(this.showDeleteConfirmation.visible){
        this.showDeleteConfirmation.visible = false;
      } else {
        this.$store.commit('booleanSearch/SET_CLONING_ERROR', false);
        this.showBatchCloneModal = false;
      }
      this.showBatchUploadModal = false;
      this.showNetfeedrUploadModal = false;
      this.showExportModal = false;
    },
    handleSelect(category, tag) {
      if(!this.selectedTags[category]) {
        this.selectedTags[category] = {tags: new Map()};
      }
      if(this.selectedTags[category].tags.has(tag.id)) this.selectedTags[category].tags.delete(tag.id);
      else this.selectedTags[category].tags.set(tag.id, tag);
      
      this.selectedTags[category].tags = new Map(this.selectedTags[category].tags);
      this.selectedTags = {...this.selectedTags};
    },
    handleSelectCategory(category){
      if(!this.selectedTags[category]) {
        this.selectedTags[category] = {tags: new Map()};
      }
      if(this.selectedTags[category].tags.size == this.tagsGroupedByCategory[category].tags.size) {
        this.selectedTags[category].tags = new Map();
      } else {
        this.selectedTags[category].tags = new Map(this.tagsGroupedByCategory[category].tags);
      }
      this.selectedTags = {...this.selectedTags};
    },
    cloneSelection(){
      this.showBatchCloneModal = true;
    },
    deleteSelection(){
      const selectedTags = Object.values(this.selectedTags).reduce((acc, data) => {
        const tags = Array.from(data.tags.keys());
        return acc.concat(tags);
      }, []);
      this.showDeleteConfirmation = {visible: true, count: selectedTags.length};
    },
    changeVisibility(visible){
      const tagsIds = Object.values(this.selectedTags).reduce((acc, data) => {
        const tags = Array.from(data.tags.keys());
        return acc.concat(tags);
      }, []);
      this.changeTagsVisibility({ tagsIds, visible, projectId: this.project_id})
        .then(() => {
          this.notifyStoreSuccess(this.$t('booleanSearch.changed_visibility'));
        })
        .catch(() => {
          this.notifyStoreError(this.$t('booleanSearch.err_changing_visibility'));
        })
    },

    onUpload () {
      this.showBatchUploadModal = true;
    },
    onNetfeedrUpload () {
      this.showNetfeedrUploadModal = true;
    },

    onExport () {
      this.showExportModal = true;
    }
  },

  components: {
    BatchCloneDeleteModal,
    UploadResourcesModal,
    ExportResourcesModal,
    CollapsibleFormSection,
    landingSidebar,
    search,
    dotsDivider,
    loaderInline,
    lastActivitySidebar,
    queryListItem,
    groupActionAttnModal,
    multiSelect,
    dropdownButton,
  }
}
</script>

<style scoped>
.select-all-checkbox {
  display: flex;
  gap: 5px;
  align-items: center;
  margin: 0 0 10px 35px;
}
.select-all-checkbox p {
  margin: 0;
  color: rgb(162, 162, 162);
  font-size: small;
  font-style: italic;
}
</style>